import React from 'react';
import { Box } from '@mui/material';

const FXWarsLogo = ({ size = 40, color = '#1976d2' }) => {
  return (
    <Box
      sx={{
        width: size * 2.5,
        height: size,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(/BearsBulls.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
      }}
    >
      {/* Additional glow effect border */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '1px solid rgba(0,255,255,0.5)',
          borderRadius: '8px',
          zIndex: 3,
          pointerEvents: 'none',
          boxShadow: 'inset 0 0 10px rgba(0,255,255,0.3)',
        }}
      />
    </Box>
  );
};

export default FXWarsLogo; 